import React from "react"
import { AddToCart } from "./AddToCart"
import { AddToCartV2 } from "./AddToCartV2"
import { ProductUnitPrice } from "./ProductUnitPrice"
import { ProductUnitDeposit } from "./ProductUnitDeposit"
import { formatDate, humanizeLabel } from "../../services/Utils"
import classNames from "classnames"

export default class Product extends React.Component  {
  constructor(props) {
    super(props)
    this.state = { expanded: props.expanded }
  }

  toggle() {
    this.props.openGallery(this.props.index)
    return
  }

  showDiscountIndicator() {
    const product = this.props.product
    return !!product.original_price || !!product.discount_indicator
  }

  renderProducerCity() {
    const product = this.props.product

    if (product.city && product.state) {
      return (
        <div className="producer-city-state">
          { product.city }, { product.state }
        </div>
      )
    } else {
      return (
        <div className="producer-city-state">
          Non-Local
        </div>
      )
    }
  }

  renderProducerName() {
    if (!this.props.showProducer) { return }
    const product = this.props.product
    return (
      <div className="product-producer">
        { product.producer_name }
      </div>
    )
  }

  renderDiscount() {
    if (!this.showDiscountIndicator()) { return }

    const classes = classNames(
      'ribbon',
      'ribbon-discount',
      { 'list': this.props.type == "list"},
      {'grid': this.props.type != "list" }
    )

    return (
      <div className={ classes }>SALE</div>
    )
  }

  renderFrozen() {
    const product = this.props.product
    if (!product.frozen) { return }

    const classes = classNames(
      'ribbon',
      'ribbon-frozen',
      { 'list': this.props.type == "list"},
      {'grid': this.props.type != "list" }
    )

    return (
      <div className={ classes }><span className="fa fa-snowflake" /></div>
    )
  }

  renderTemporarilyUnavailable() {
    const product = this.props.product
    if (product.unavailable_type != 'temporary') { return }

    const classes = classNames(
      'overlay',
      'overlay-temporary',
      { 'list': this.props.type == "list"},
      {'grid': this.props.type != "list" }
    )

    return (
      <div className={ classes }>TEMPORARILY UNAVAILABLE</div>
    )
  }

  renderPreorder() {
    const product = this.props.product
    if (product.unavailable_type != 'preorder') { return }

    const classes = classNames(
      'overlay',
      'overlay-preorder',
      { 'list': this.props.type == "list"},
      {'grid': this.props.type != "list" }
    )

    return (
      <div className={ classes }>PREORDER</div>
    )
  }

  renderProductImage() {
    if (!this.props.showImage) { return }
    const product = this.props.product

    const imageContainerClassNames = classNames(
      'product-image',
      'image-container',
      { 'list': this.props.type == "list"},
      { 'grid': this.props.type != "list" },
      { 'short-sale': product.is_short_sale }
    )

    var image = this.props.product.product_photo.small_url
    return (
      <div className={ imageContainerClassNames }>
        <img src={image} width="100%" />
        { this.renderDiscount() }
        { this.renderFrozen() }
        { this.renderTemporarilyUnavailable() }
        { this.renderPreorder() }
      </div>
    )
  }

  renderShortSaleBadge() {
    const product = this.props.product
    if (!product.is_short_sale) { return }

    const labelType = humanizeLabel(product.date_label_type)

    return (
      <div className="mt-1">
        <span className="badge badge-dark">
          Short Sale: { labelType } { formatDate(product.short_sale_date_label_on) }
        </span>
      </div>
    )
  }

  renderNote() {
    if (!this.props.product.note) { return }

    return (
      <div className="note mt-1 mb-2">
        <span className='fa fa-info-circle mr-1'/>
        { this.props.product.note}
      </div>
    )
  }


  renderListProduct() {
    const product = this.props.product
    const AddToCartComponent = this.props.anyDateAvailability ? AddToCartV2 : AddToCart

    return (
      <div className="product-card list">
        <div className="product-item list ">
          <div className='d-flex'>
            <div> { this.renderProductImage() } </div>
            <div className='row w-100'>
              <div className='col-12 col-md-8 col-lg-9' onClick={this.toggle.bind(this)}>
                <div className="product-details list cursor-pointer">
                  <div className='producer-details d-sm-flex mb-1'>
                    { this.renderProducerName() }
                    { this.renderProducerCity() }
                  </div>
                  <div className="product-name">
                    { product.name }
                  </div>
                  <div className='product-unit'>
                    {this.props.product.unit}
                  </div>
                  { this.renderShortSaleBadge() }
                  <div className='font-weight-bold mt-2'>
                    <ProductUnitPrice product_unit={ product } showPricing={ this.props.showPricing } />
                  </div>
                  { this.renderNote() }
                  <div className="product-description">
                    <em>{ product.description }</em>
                  </div>
                </div>
              </div>
              <div className='col-3 col-md-4 col-lg-3'>
                <div className="mt-2">
                  <AddToCartComponent
                    product_unit={ product }
                    requestedOn={ this.props.requestedOn }
                    showAvailability={ this.props.showAvailability }
                    seller_id={ product.seller_id }
                    showPricing={ this.props.showPricing }
                    cartEnabled={ this.props.cartEnabled }
                    addItem={ this.props.addItem }
                    src='catalog_list'
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderTableProduct() {
    const product = this.props.product
    const AddToCartComponent = this.props.anyDateAvailability ? AddToCartV2 : AddToCart

    const rowClasses = classNames(
      'product-row',
      { 'unavailable': product.unavailable_type == 'indefinite' }
    )

    return (
      <tr className={ rowClasses }>
        <td className="cursor-pointer product-table-producer" onClick={this.toggle.bind(this)}>
          { this.renderProducerName() }
          { this.renderProducerCity() }
        </td>
        <td className="cursor-pointer product-table-product" onClick={this.toggle.bind(this)}>
          <div className="product-name">{ product.name }</div>
          <div className="product-unit">{ product.unit }</div>
          { this.renderShortSaleBadge() }
          { this.renderNote() }
        </td>
        <td className="product-table-price">
          <ProductUnitPrice product_unit={ product } showPricing={ this.props.showPricing } />
        </td>
        <td className="product-table-actions">
          <AddToCartComponent
            product_unit={ product }
            requestedOn={ this.props.requestedOn }
            showAvailability={ this.props.showAvailability }
            seller_id={ product.seller_id }
            showPricing={ this.props.showPricing }
            cartEnabled={ this.props.cartEnabled }
            addItem={ this.props.addItem }
            src='catalog_table'
          />
        </td>
      </tr>
    )
  }

  renderGridProduct() {
    const AddToCartComponent = this.props.anyDateAvailability ? AddToCartV2 : AddToCart

    var product = this.props.product
    var product_unit = this.props.product

    const productContainerClasses  = classNames(
      'product-card', 'grid',
      { 'unavailable': product_unit.unavailable_type == 'indefinite' }
    )

    return (
      <div className={ productContainerClasses }>
        <div className="product-item grid drop-shadow-hover d-flex flex-column justify-content-between">
          <div className='flex-fill cursor-pointer' onClick={this.toggle.bind(this)}>
            { this.renderProductImage() }
            <div className="product-details grid">
              <div className='producer-details mb-1'>
                { this.renderProducerName() }
                { this.renderProducerCity() }
              </div>
              <div className="product-name grid">
                {this.props.product.name}
              </div>
              <div className='product-unit'>
                {this.props.product.unit}
              </div>
              { this.renderShortSaleBadge() }
              <div className='h5 mt-2'>
                <ProductUnitPrice product_unit={ product } showPricing={ this.props.showPricing } />
              </div>
              <ProductUnitDeposit product_unit={ product }/>
              { this.renderNote() }
            </div>
          </div>
          <div className="product-details grid">
            <AddToCartComponent
               anyDateAvailability={ this.props.anyDateAvailability }
               product_unit={ product }
               requestedOn={ this.props.requestedOn }
               showAvailability={ this.props.showAvailability }
               seller_id={ product.seller_id }
               showPricing={ this.props.showPricing }
               cartEnabled={ this.props.cartEnabled }
               addItem={ this.props.addItem }
               src='catalog_card'
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    if (this.props.type == "table") {
      return this.renderTableProduct()
    } else if (this.props.type == "list") {
      return this.renderListProduct()
    } else {
      return this.renderGridProduct()
    }
  }
}
